import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSearchbar, PopoverController } from '@ionic/angular';
declare const google: any;

@Component({
  selector: 'app-custom-location-maps-picker',
  templateUrl: 'custom-location-maps-picker.component.html',
  styleUrls: ['./custom-location-maps-picker.page.scss']
})
export class CustomLocationMapsPickerComponent implements OnInit {
  @ViewChild('placePickerSB', { static: false })
  searchBar: IonSearchbar;
  searchResults: Array<any> = [];  noResultsFound = false;
  isLoading = false;
  searchFilter = '';
  mapsService: any;
  dataAddress: IAddress = {
    city: '',
    country: '',
    latitude: '',
    longitude: '',
    street: '',
    state: '',
    zip: '',
    locality: '',
    ext_number: ''
  };
  constructor(
    public popoverController: PopoverController,
  ) {
    this.mapsService = new google.maps.places.AutocompleteService();
  }

  ngOnInit() {
    setTimeout(() => {
      this.searchBar.setFocus();
    }, 800);
  }

  onInput(event: any) {
    const query = event.target.value;
    this.searchResults = [];

    if (!query) {
      return;
    }

    const config = {
      types: [], // other types available in the API: 'address 'establishment', 'regions', and 'cities'
      input: query,
    };
    this.isLoading = true;
    this.mapsService.getPlacePredictions(config, (predictions, status) => {
      if (predictions && predictions.length > 0) {
        predictions.forEach((prediction) => {
          this.searchResults.push(prediction);
        });
      } else {
        const locationDesc = {
          description: query,
          place_id: 'default_place_id',
        };

        this.searchResults.push(locationDesc);
      }
      this.isLoading = false;
    });
  }

  async selectLocation(place: any) {
    const geocoder = new google.maps.Geocoder();
    const { results } = await geocoder.geocode({ placeId: place.place_id });
    console.log('results: ', results);
    if (results[0]) {
      this.dataAddress.longitude = (results[0].geometry.location.lng()) ? results[0].geometry.location.lng() : '';
      this.dataAddress.latitude = (results[0].geometry.location.lat()) ? results[0].geometry.location.lat() : '';
      for (var i = 0; i < results[0].address_components.length; i++) {
        for (var j = 0; j < results[0].address_components[i].types.length; j++) {
          if (results[0].address_components[i].types[j] == "postal_code") {
            this.dataAddress.zip = results[0].address_components[i].long_name;
          }
        }

        for (var j = 0; j < results[0].address_components[i].types.length; j++) {
          if (results[0].address_components[i].types[j] == "street_number") {
            this.dataAddress.ext_number = results[0].address_components[i].long_name;
          }
        }

        for (var j = 0; j < results[0].address_components[i].types.length; j++) {
          if (results[0].address_components[i].types[j] == "route") {
            this.dataAddress.street = results[0].address_components[i].long_name;
          }
        }

        for (var j = 0; j < results[0].address_components[i].types.length; j++) {
          if (results[0].address_components[i].types[j] == "sublocality") {
            this.dataAddress.locality = results[0].address_components[i].long_name;
          }
        }

        if (results[0].address_components[i].types[0] === "street_number") {
          this.dataAddress.ext_number = results[0].address_components[i].long_name
        }

        if (results[0].address_components[i].types[0] === "administrative_area_level_1") {
          this.dataAddress.state = results[0].address_components[i].long_name;
        }

        if (results[0].address_components[i].types[0] === "locality") {
          this.dataAddress.city = results[0].address_components[i].long_name;
        }
        if (results[0].address_components[i].types[0] === "country") {
          this.dataAddress.country = results[0].address_components[i].long_name;
        }
      }
    }
    if(this.dataAddress.city && this.dataAddress.city !== ''){
      const splitFullStreet = place.description.split(', ' + this.dataAddress.city);
      place.description = splitFullStreet[0];
    }

    this.popoverController.dismiss({
      description: place.description,
      id: place.place_id,
      detailAddress: this.dataAddress
    });
  }

  closeModal(){
    this.popoverController.dismiss();
  }
}

export interface IAddress {
  city?: string,
  country?: string,
  latitude?: string,
  longitude?: string,
  street?: string,
  state?: string,
  zip?: string,
  locality?: string,
  ext_number?: string
}